import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, InputGroup, Form, Button } from "react-bootstrap";
import { FaRegEnvelope, FaLock, FaRegCheckCircle } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import APIServicenew from "../utils/APIGeneralService";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({});
  const [load, setLoad] = useState(false);
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const headers = { "auth-token": authToken };

  const validate = () => {
    const errors = {};
    if (!email) {
      errors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Email is invalid.";
    }
    if (!password) {
      errors.password = "Password is required.";
    } else if (password.length < 6) {
      errors.password = "Password must be at least 6 characters.";
    } else if (password.length > 20) {
      errors.password = "Password must not exceed 20 characters.";
    }
    if (!otp) {
      errors.otp = "OTP is required.";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoad(true);
    if (validate()) {
      const res = await APIServices.post(
        "admin/auth/reset_password",
        {
          email,
          password,
          otp,
        },
        headers
      );
      if (res?.data?.status === true) {
        setLoad(false);
        showToast(res?.data?.message || "Password Reset Successful!", "success");
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
        setLoad(false);
      }
    } else {
      setLoad(false);
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (errors.email) {
      setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (errors.password) {
      setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
    }
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
    if (errors.otp) {
      setErrors((prevErrors) => ({ ...prevErrors, otp: "" }));
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  return (
    <>
      <div className="login_sec reset_password_sec">
        <Container fluid className="p-0">
          <Row className="gx-0 align-items-center">
            <Col md={6} lg={6}>
              <div className="login_graph p-4">
                <img
                  src="/images/login_frame.svg"
                  className="img-fluid"
                  alt="login"
                />
              </div>
            </Col>
            <Col md={6} lg={6}>
              <div className="login_form p-4">
                <div className="text-center mb-4">
                  <img
                    src='/images/alf_logo.svg'
                    alt="Logo"
                    className="img-fluid"
                    style={{ width: '200px' }} // Adjust logo size
                  />
                </div>
                <h2 className="font_blue_20 font-600 mb-4 line-height26 text-center">
                  Reset Password
                </h2>
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="formEmail">
                    <Form.Label className="font_blue_14 font-500 mb-3">
                      Email ID
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="email"
                        placeholder="Enter Email ID"
                        value={email}
                        onChange={handleEmailChange}
                      />
                      <InputGroup.Text>
                        <FaRegEnvelope />
                      </InputGroup.Text>
                    </InputGroup>
                    {errors.email && (
                      <div className="text-danger mt-2">{errors.email}</div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formPassword">
                    <Form.Label className="font_blue_14 font-500 mb-3">
                      New Password
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="password"
                        placeholder="Enter New Password"
                        value={password}
                        onChange={handlePasswordChange}
                        maxLength={20}
                      />
                      <InputGroup.Text>
                        <FaLock />
                      </InputGroup.Text>
                    </InputGroup>
                    {errors.password && (
                      <div className="text-danger mt-2">{errors.password}</div>
                    )}
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="formOtp">
                    <Form.Label className="font_blue_14 font-500 mb-3">
                      OTP
                    </Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={handleOtpChange}
                      />
                      <InputGroup.Text>
                        <FaRegCheckCircle />
                      </InputGroup.Text>
                    </InputGroup>
                    {errors.otp && (
                      <div className="text-danger mt-2">{errors.otp}</div>
                    )}
                  </Form.Group>

                  <Button className="btn red_button w-100" type="submit" disabled={load}>
                    {load ? "Processing..." : "Reset Password"}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </>
  );
};

export default ResetPassword;
